import React, { Component } from 'react';
import { Card, FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    updateValue
} from '../actions/index';
import {
    EMPLOYEE_COUNT,
    OVERRIDE_POINTS,
    PARTICIPATION,
    REWARD_BUDGET,
    REWARD_VALUE
} from '../actions/types';

class Overview extends Component {

    render() {
        const { employeeCount, overridePoints, participation, rewardBudget, rewardValue, updateValue } = this.props;
        return (
            <Card>
                <Card.Header className='card-title'>Overview</Card.Header>
                <InputGroup>
                    <FormGroup>
                        <label>Number of Employees:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, EMPLOYEE_COUNT)} defaultValue={employeeCount} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup>
                        <label>Monthly Reward Budget (in Dollars):</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, REWARD_BUDGET)} defaultValue={rewardBudget} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup>
                        <label>Value of Reward (in Dollars):</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, REWARD_VALUE)} defaultValue={rewardValue} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup>
                        <label>Approximate Participation (in Percentage):</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, PARTICIPATION)} defaultValue={participation} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup>
                        <label>Override Calculated Points Value (May exceed budget):</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, OVERRIDE_POINTS)} defaultValue={overridePoints} />
                    </FormGroup>
                </InputGroup>
            </Card>
        );
    }
}

Overview.propTypes = {
    employeeCount: PropTypes.number,
    overridePoints: PropTypes.number,
    participation: PropTypes.number,
    rewardBudget: PropTypes.number,
    rewardValue: PropTypes.number,
    updateValue: PropTypes.func
};

function mapStateToProps(state) {
    return {
        employeeCount: state.calc.get(EMPLOYEE_COUNT),
        overridePoints: state.calc.get(OVERRIDE_POINTS),
        participation: state.calc.get(PARTICIPATION),
        rewardBudget: state.calc.get(REWARD_BUDGET),
        rewardValue: state.calc.get(REWARD_VALUE)
    };
}

export default connect(mapStateToProps, {
    updateValue
})(Overview);
